// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__iPVsc","postfix":"styles_postfix__4Jcud","prefix":"styles_prefix__Ycs1J"};